import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Chip,
// Alert,
Radio, Button, MenuItem, RadioGroup, Typography, FormControl, OutlinedInput, InputAdornment, FormHelperText, FormControlLabel, TextareaAutosize } from '@mui/material';
import useStyles from './../styles';
import { useStore } from 'src/stores';
import { dateToFormat } from 'src/utils/date';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
import { capitalizeFirstLetter } from 'src/utils/capitalizeFirstLetter';
import { BackdropLoader, SelectMenu, toast } from '@livable/saas-react-components';
export const ModalContent = observer(_ref => {
  var _store$payment$getCur, _store$payment$getCur3, _store$payment$getCur4, _store$payment$getCur5, _store$payment$getCur6, _store$payment$getCur7, _store$payment$getCur8, _store$payment$getCur9, _store$payment$getCur0, _store$payment$getCur1, _store$payment$getCur10, _store$payment$getCur11, _store$payment$getCur12, _store$payment$getCur13, _store$payment$getCur14, _store$payment$getCur15, _store$payment$getCur16, _store$payment$getCur17, _store$payment$getCur18, _store$payment$getCur19;
  let currentInvoice = _ref.currentInvoice,
    reloadData = _ref.reloadData,
    setShowInvoice = _ref.setShowInvoice,
    handleModalClose = _ref.handleModalClose;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const modalFooterClasses = useModalFooterStyles();
  const lineItemsArray = (_store$payment$getCur = store.payment.getCurrentStripeInvoices(currentInvoice)) === null || _store$payment$getCur === void 0 || (_store$payment$getCur = _store$payment$getCur.lineItems) === null || _store$payment$getCur === void 0 ? void 0 : _store$payment$getCur.map(i => {
    return {
      stripeLineItemId: i.stripeLineItemId,
      amount: 0
    };
  });
  const _useState = useState(lineItemsArray),
    _useState2 = _slicedToArray(_useState, 2),
    lineItems = _useState2[0],
    setLineItems = _useState2[1];
  const updateLineItemById = (id, newData) => {
    setLineItems(prevItems => prevItems.map(item => item.stripeLineItemId === id ? _objectSpread(_objectSpread({}, item), newData) : item));
  };
  const _useState3 = useState('Refund'),
    _useState4 = _slicedToArray(_useState3, 2),
    invoiceValue = _useState4[0],
    setInvoiceValue = _useState4[1];
  const handleInvoiceChange = event => {
    setInvoiceValue(event.target.value);
  };
  const reasonList = [{
    key: 'BillingErrorUtility',
    value: 'Billing Error - Utility'
  }, {
    key: 'BillingErrorFee',
    value: 'Billing Error - Fee'
  }, {
    key: 'Overcharge',
    value: 'Overcharge'
  }, {
    key: 'ServiceNotRendered',
    value: 'Service Not Rendered'
  }, {
    key: 'ClientDispute',
    value: 'Client Dispute'
  }, {
    key: 'LateFeeWaived',
    value: 'Late Fee Waived'
  }, {
    key: 'StatementIssue',
    value: 'USPS statement Issue'
  }, {
    key: 'UnitVacant',
    value: 'Unit Vacant'
  }, {
    key: 'PromotionalCredit',
    value: 'Promotional Credit'
  }, {
    key: 'Other',
    value: 'Other'
  }];
  const _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    reason = _useState6[0],
    setReason = _useState6[1];
  const _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    reasonError = _useState8[0],
    setReasonError = _useState8[1];
  const _useState9 = useState(''),
    _useState0 = _slicedToArray(_useState9, 2),
    comment = _useState0[0],
    setComment = _useState0[1];
  const _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isValidation = _useState10[0],
    setIsValidation = _useState10[1];
  const _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    isValidationError = _useState12[0],
    setIsValidationError = _useState12[1];
  const handleValidation = _ref2 => {
    let _ref2$isReason = _ref2.isReason,
      isReason = _ref2$isReason === void 0 ? false : _ref2$isReason;
    setIsValidation(true);
    setIsValidationError(false);
    if (!isReason && !reason) {
      setReasonError(true);
      setIsValidationError(true);
      return true;
    }
    return false;
  };
  const handleSubmit = async () => {
    var _store$payment$getCur2;
    if (handleValidation({
      isReason: false
    })) return;
    const data = {
      requestType: invoiceValue,
      comment: comment.trim(),
      stripeInvoiceId: (_store$payment$getCur2 = store.payment.getCurrentStripeInvoices(currentInvoice)) === null || _store$payment$getCur2 === void 0 ? void 0 : _store$payment$getCur2.stripeInvoiceId,
      reason: reason,
      refundCreditRequests: lineItems.map(li => {
        return {
          stripeLineItemId: li.stripeLineItemId,
          amount: +li.amount
        };
      })
    };
    const resp = await store.payment.postRefundOrCreditAsync.run(data);
    if (resp && resp.isSuccessful) toast('success', {
      body: ['Successfully saved']
    });
    setShowInvoice(false);
    reloadData();
    handleModalClose();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.payment.postRefundOrCreditAsync.inProgress
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.refundCreditInvoice
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.invoiceBlockTitle, " small")
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('Invoice details'))), /*#__PURE__*/React.createElement("div", {
    className: classes.invoiceDetails
  }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Invoice number:"), /*#__PURE__*/React.createElement("td", null, (_store$payment$getCur3 = store.payment.getCurrentStripeInvoices(currentInvoice)) === null || _store$payment$getCur3 === void 0 ? void 0 : _store$payment$getCur3.invoiceNumber), /*#__PURE__*/React.createElement("td", null, "Total amount:"), /*#__PURE__*/React.createElement("td", null, "$", (_store$payment$getCur4 = store.payment.getCurrentStripeInvoices(currentInvoice)) === null || _store$payment$getCur4 === void 0 ? void 0 : _store$payment$getCur4.amount)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Type:"), /*#__PURE__*/React.createElement("td", null, (_store$payment$getCur5 = store.payment.getCurrentStripeInvoices(currentInvoice)) === null || _store$payment$getCur5 === void 0 ? void 0 : _store$payment$getCur5.type), /*#__PURE__*/React.createElement("td", null, "Status:"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Chip, {
    label: capitalizeFirstLetter((_store$payment$getCur6 = store.payment.getCurrentStripeInvoices(currentInvoice)) === null || _store$payment$getCur6 === void 0 ? void 0 : _store$payment$getCur6.status),
    variant: ((_store$payment$getCur7 = store.payment.getCurrentStripeInvoices(currentInvoice)) === null || _store$payment$getCur7 === void 0 ? void 0 : _store$payment$getCur7.status) === 'Failed' ? 'critical' : ((_store$payment$getCur8 = store.payment.getCurrentStripeInvoices(currentInvoice)) === null || _store$payment$getCur8 === void 0 ? void 0 : _store$payment$getCur8.status) === 'Processing' ? 'warning' : ((_store$payment$getCur9 = store.payment.getCurrentStripeInvoices(currentInvoice)) === null || _store$payment$getCur9 === void 0 ? void 0 : _store$payment$getCur9.status) === 'Upcoming' ? 'info' : 'success'
  }))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Description:"), /*#__PURE__*/React.createElement("td", null, (_store$payment$getCur0 = store.payment.getCurrentStripeInvoices(currentInvoice)) !== null && _store$payment$getCur0 !== void 0 && _store$payment$getCur0.description ? (_store$payment$getCur1 = store.payment.getCurrentStripeInvoices(currentInvoice)) === null || _store$payment$getCur1 === void 0 ? void 0 : _store$payment$getCur1.description : 'N/A'), /*#__PURE__*/React.createElement("td", null, "Date:"), /*#__PURE__*/React.createElement("td", null, (_store$payment$getCur10 = store.payment.getCurrentStripeInvoices(currentInvoice)) !== null && _store$payment$getCur10 !== void 0 && _store$payment$getCur10.paidAt ? dateToFormat((_store$payment$getCur11 = store.payment.getCurrentStripeInvoices(currentInvoice)) === null || _store$payment$getCur11 === void 0 ? void 0 : _store$payment$getCur11.paidAt) : 'N/A')), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Payment method:"), /*#__PURE__*/React.createElement("td", null, (_store$payment$getCur12 = store.payment.getCurrentStripeInvoices(currentInvoice)) !== null && _store$payment$getCur12 !== void 0 && _store$payment$getCur12.brand && (_store$payment$getCur13 = store.payment.getCurrentStripeInvoices(currentInvoice)) !== null && _store$payment$getCur13 !== void 0 && _store$payment$getCur13.last4 ? "".concat(capitalizeFirstLetter((_store$payment$getCur14 = store.payment.getCurrentStripeInvoices(currentInvoice)) === null || _store$payment$getCur14 === void 0 ? void 0 : _store$payment$getCur14.brand), " \u2022\u2022\u2022\u2022 ").concat((_store$payment$getCur15 = store.payment.getCurrentStripeInvoices(currentInvoice)) === null || _store$payment$getCur15 === void 0 ? void 0 : _store$payment$getCur15.last4) : 'N/A'), /*#__PURE__*/React.createElement("td", null, "Refunded/Credited:"), /*#__PURE__*/React.createElement("td", null, "$", (_store$payment$getCur16 = store.payment.getCurrentStripeInvoices(currentInvoice)) === null || _store$payment$getCur16 === void 0 ? void 0 : _store$payment$getCur16.adjustments)))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.invoiceBlockTitle, " small")
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('Actions'))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RadioGroup, {
    value: invoiceValue,
    onChange: handleInvoiceChange
  }, /*#__PURE__*/React.createElement("div", {
    onClick: () => setInvoiceValue('Refund'),
    className: classes.invoiceRadio
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "Refund",
    control: /*#__PURE__*/React.createElement(Radio, null)
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "Refund invoice"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "Return money directly to the client for a paid invoice.")), /*#__PURE__*/React.createElement("div", {
    onClick: () => setInvoiceValue('Credit'),
    className: classes.invoiceRadio
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    value: "Credit",
    control: /*#__PURE__*/React.createElement(Radio, null)
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, "Credit invoice"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, "Apply a credit to reduce the balance of an open or future invoice. No money will be refunded.")))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.invoiceBlockTitle, " small")
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t("".concat(invoiceValue === 'Refund' ? 'Refund amount' : 'Credit amount'))), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t("".concat(invoiceValue === 'Refund' ? 'The total amount of refund cannot exceed the original invoice total.' : 'The total amount of credit cannot exceed the original invoice total.')))), /*#__PURE__*/React.createElement("div", {
    className: classes.invoiceTotal
  }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Line item"), /*#__PURE__*/React.createElement("td", null, "Price x 1"), /*#__PURE__*/React.createElement("td", null, "Count"), /*#__PURE__*/React.createElement("td", null, "Orig. amount"), /*#__PURE__*/React.createElement("td", null, t("".concat(invoiceValue === 'Refund' ? 'Refund' : 'Credit'))), /*#__PURE__*/React.createElement("td", null, "Rem. balance"))), /*#__PURE__*/React.createElement("tbody", null, (_store$payment$getCur17 = store.payment.getCurrentStripeInvoices(currentInvoice)) === null || _store$payment$getCur17 === void 0 || (_store$payment$getCur17 = _store$payment$getCur17.lineItems) === null || _store$payment$getCur17 === void 0 ? void 0 : _store$payment$getCur17.map(i => /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, i.productName), /*#__PURE__*/React.createElement("td", null, "$", i.price), /*#__PURE__*/React.createElement("td", null, i.quantity), /*#__PURE__*/React.createElement("td", null, "$", i.amountPaid), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    onKeyPress: event => {
      if (!/[0-9]|[.,]/.test(event.key)) {
        event.preventDefault();
      }
    }
  }, /*#__PURE__*/React.createElement(OutlinedInput, {
    id: "resident-payment",
    type: "text",
    disabled: i.amountPaid === 0 || i.remainingBalance === 0,
    value: lineItems.find(u => u.stripeLineItemId === i.stripeLineItemId).amount,
    onChange: e => {
      if (/^(?:|(?:\d{1,2})([.,]\d{0,2})?)$/.test(e.target.value) && +e.target.value <= i.amountPaid) {
        updateLineItemById(i.stripeLineItemId, {
          stripeLineItemId: i.stripeLineItemId,
          amount: e.target.value
        });
      }
    },
    placeholder: "Not set",
    startAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
      position: "start"
    }, "$")
  }))), /*#__PURE__*/React.createElement("td", null, "$", i.remainingBalance))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, "Total"), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null, "$", (_store$payment$getCur18 = store.payment.getCurrentStripeInvoices(currentInvoice)) === null || _store$payment$getCur18 === void 0 ? void 0 : _store$payment$getCur18.lineItems.reduce((accumulator, currentValue) => accumulator + currentValue.amountPaid, 0)), /*#__PURE__*/React.createElement("td", null), /*#__PURE__*/React.createElement("td", null, "$", (_store$payment$getCur19 = store.payment.getCurrentStripeInvoices(currentInvoice)) === null || _store$payment$getCur19 === void 0 ? void 0 : _store$payment$getCur19.lineItems.reduce((accumulator, currentValue) => accumulator + currentValue.credit, 0)))))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.invoiceBlockTitle, " small")
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t("".concat(invoiceValue === 'Refund' ? 'Refund reason' : 'Credit reason')))), /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    value: reason,
    error: reasonError,
    label: 'Select reason',
    onChange: e => {
      setReason(e.target.value);
      setReasonError(false);
      handleValidation({
        isReason: true
      });
    }
  }, reasonList.map(_ref3 => {
    let key = _ref3.key,
      value = _ref3.value;
    return /*#__PURE__*/React.createElement(MenuItem, {
      value: key,
      key: key
    }, t("".concat(value)));
  })), isValidation && reasonError && /*#__PURE__*/React.createElement(FormControl, {
    error: true
  }, /*#__PURE__*/React.createElement(FormHelperText, null, "Reason can not be empty"))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.invoiceBlockTitle, " small")
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('Comment'))), /*#__PURE__*/React.createElement("div", {
    className: classes.invoiceTextArea
  }, /*#__PURE__*/React.createElement(TextareaAutosize, {
    minRows: 3,
    placeholder: "Type comment",
    value: comment,
    onChange: e => setComment(e.target.value)
  })), /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooterStandart
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: handleModalClose
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    variant: "contained",
    disabled: isValidationError || store.payment.postRefundOrCreditAsync.inProgress,
    onClick: () => handleSubmit()
  }, t("".concat(invoiceValue === 'Refund' ? 'Refund' : 'Credit'))))))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: false
  }));
});